import {INVOICES_DOWNLOAD_URL} from "../config";
import {getAccessToken} from "./api/AuthApi";

const InvoiceStorage = {

  getUrl(invoiceNr) {
    return INVOICES_DOWNLOAD_URL.replace(":invoice_nr", invoiceNr);
  },

  async download(url) {
    const token = getAccessToken();

    fetch(url, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
    .then(response => {
      if (!response.ok) throw new Error("Network response was not ok");
      // Try to get filename from Content-Disposition header
      let filename = url.split("/").pop();
      const disposition = response.headers.get("Content-Disposition");
      if (disposition && disposition.indexOf("filename=") !== -1) {
        const match = disposition.match(/filename="?([^";]+)"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }
      return response.blob().then(blob => ({ blob, filename }));
    })
    .then(({ blob, filename }) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    })
    .catch(error => {
      console.error("Download failed:", error);
    });
  }

}

export default InvoiceStorage;
